import truyenThong1 from "../../../assets/images/TruyenThong/1.png";
import truyenThong2 from "../../../assets/images/TruyenThong/2.png";
import truyenThong3 from "../../../assets/images/TruyenThong/3.png";
import truyenThong4 from "../../../assets/images/TruyenThong/4.png";
import truyenThong5 from "../../../assets/images/TruyenThong/5.png";
import truyenThong6 from "../../../assets/images/TruyenThong/6.png";
const banTruyenThong = {
  title: "Ban",
  name: "Truyền Thông",
  registerMes:
    "Bấm đăng kí để có cơ hội trở thành thành viên của ban truyền thông nhé",
  clb: "student informatic club",
  btn: "Đăng kí CTV",
  imagesIntro: [truyenThong1, truyenThong2, truyenThong3, truyenThong4, truyenThong5, truyenThong6],
  mission: [
    `Là đầu mối chịu trách nghiệm quản lí và truyền tải các thông tin chính thức của câu lạc bộ`,
    `Xây dựng, duy trì và phát triển hình ảnh của CLB, phụ trách thiết kế ấn phẩm hình ảnh, clip cho các nền tảng truyền thông của câu lạc bộ `,
  ],
  advantage: [
    `Nâng cao kiến thức, hoàn thiện bản thân`,
    `Trau dồi khả năng tổ chức và lên kế hoạch`,
    `Rèn luyện tinh thần học hỏi, tinh thần trách nghiệm`,
    `Thoả đam mê sáng tạo với 2 tiểu ban chính là content và design`,
    `Là nơi lý tưởng để tìm kiếm tri kỉ cùng chung tâm hồn nghệ thuật`,
  ],
};

export default banTruyenThong;
